"use client";

import { useEffect, useRef } from "react";

/**
 * While `waiting` is true, asks again the moment the browser says it is back online, so the "Unplugged"
 * scene clears itself without a click. `retry` is the failed query's own refetch.
 */
export function useRetryWhenOnline(waiting: boolean, retry: (() => unknown) | undefined): void {
  const latest = useRef(retry);
  useEffect(() => {
    latest.current = retry;
  }, [retry]);

  useEffect(() => {
    if (!waiting) return undefined;
    const onOnline = () => void latest.current?.();
    window.addEventListener("online", onOnline);
    return () => window.removeEventListener("online", onOnline);
  }, [waiting]);
}
